var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"dyk-container"},[_c('b-col',{attrs:{"sm":"12"}},[_c('h3',[_vm._v(_vm._s(_vm.$t('didYouKnow')))])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"12"}},[_c('p',[_vm._v("\n      "+_vm._s(_vm.$t('didYouKnowContent'))+"\n      "),_c('a',{attrs:{"href":"#"}},[_c('b',[_vm._v(_vm._s(_vm.$t('learnMore')))])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1565c45e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DidYouKnow.vue
// module id = Q/Jf
// module chunks = 1